import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);

const THEMES = ["warm", "terminal", "industrial", "technical", "dark", "light"];
const BLUEPRINTS = ["off", "light", "medium"];
const DENSITIES = ["compact", "standard"];

const DEFAULTS = { theme: "warm", blueprint: "medium", density: "standard" };

function read(key, fallback, allowed) {
  try {
    const v = localStorage.getItem(key);
    return v && allowed.includes(v) ? v : fallback;
  } catch { return fallback; }
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => read("r4pro_theme", DEFAULTS.theme, THEMES));
  const [blueprint, setBlueprintState] = useState(() => read("r4pro_blueprint", DEFAULTS.blueprint, BLUEPRINTS));
  const [density, setDensityState] = useState(() => read("r4pro_density", DEFAULTS.density, DENSITIES));

  useEffect(() => {
    const root = document.documentElement;
    root.dataset.theme = theme;
    root.dataset.blueprint = blueprint;
    root.dataset.density = density;
  }, [theme, blueprint, density]);

  const setTheme = useCallback((v) => {
    if (!THEMES.includes(v)) return;
    setThemeState(v);
    try { localStorage.setItem("r4pro_theme", v); } catch (_) { /* ignore */ }
  }, []);
  const setBlueprint = useCallback((v) => {
    if (!BLUEPRINTS.includes(v)) return;
    setBlueprintState(v);
    try { localStorage.setItem("r4pro_blueprint", v); } catch (_) { /* ignore */ }
  }, []);
  const setDensity = useCallback((v) => {
    if (!DENSITIES.includes(v)) return;
    setDensityState(v);
    try { localStorage.setItem("r4pro_density", v); } catch (_) { /* ignore */ }
  }, []);

  return (
    <ThemeContext.Provider value={{
      theme, blueprint, density,
      setTheme, setBlueprint, setDensity,
      themes: THEMES, blueprints: BLUEPRINTS, densities: DENSITIES,
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
  return ctx;
}
